import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import uuidGen from 'web-app/util/uuid';

import * as Actions from './actions';

const Recipient = Record({
    image: '',
    loginId: '',
    name: '',
    status: '',
});

const RecipientStat = Record({
    login: Recipient(),
    seen: false,
});

export const recipientStatFromAPI = data =>
    new RecipientStat({
        ...data,
        login: new Recipient(data.login),
    });

const RecipientsModalState = Record({
    isVisible: false,
    fetched: false,
    recipients: List(),
    originatorId: null,
    smsIdentifier: undefined,
});

export default handleActions(
    {
        [Actions.show.type]: (state, {payload}) =>
            new RecipientsModalState({
                isVisible: true,
                originatorId: payload.originatorId,
                smsIdentifier: payload.smsIdentifier,
            }),
        [Actions.showRecipients.type]: (state, {payload}) =>
            new RecipientsModalState({
                isVisible: true,
                fetched: true,
                recipients: payload.recipients.map(
                    rec =>
                        new RecipientStat({
                            login: new Recipient({
                                name: rec,
                                loginId: uuidGen(),
                            }),
                        }),
                ),
                smsIdentifier: payload.smsIdentifier,
            }),

        [Actions.hide.type]: () => new RecipientsModalState(),
        [Actions.fetchRecipientsSuccess.type]: (state, {payload}) =>
            state.merge({
                fetched: true,
                recipients: payload.recipients,
            }),
    },
    RecipientsModalState(),
);
